import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';
import type { AvatarSizeProps } from '.';

interface WrapperProps {
  $size?: AvatarSizeProps;
  $background?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  --_scope-avatar-size: ${size(4)};
  --_scope-avatar-radius: ${size(1.25)};
  --_scope-avatar-initials-size: ${size(1.75)};

  position: relative;
  width: var(--_scope-avatar-size);
  height: var(--_scope-avatar-size);
  border-radius: var(--_scope-avatar-radius);

  ${({ $size }) =>
    $size === 'small'
      ? css`
          --_scope-avatar-size: ${size(3)};
          --_scope-avatar-radius: ${size(1)};
          --_scope-avatar-initials-size: ${size(1.25)};
        `
      : $size === 'large'
        ? css`
          --_scope-avatar-size: ${size(6)};
          --_scope-avatar-radius: ${size(2.25)};
          --_scope-avatar-initials-size: ${size(2.5)};
        `
        : undefined}

${({ $background }) =>
  $background &&
  css`
          background-color: var(--c-semantic-neutral-300);
        `}
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: inherit;
`;

export const Initials = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--_scope-avatar-initials-size);
  font-weight: var(--font-weight-bold);
  text-align: center;
  text-transform: uppercase;
  user-select: none;
`;
